module.exports = __webpack_public_path__ + "static/media/login.3f50991b.svg";